var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form-wrapper",
        { staticClass: "form-wrapper", attrs: { validator: _vm.$v.model } },
        [
          _c(
            "form-group",
            { attrs: { label: "Customer Id", name: "customerId" } },
            [
              _c("md-input", {
                model: {
                  value: _vm.model.customerId,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.model,
                      "customerId",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "model.customerId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }